import { Input } from "@/components/ui/input";
import { Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FavoriteFilter } from "@/components/common/FavoriteFilter";
import { useTranslation } from "react-i18next";

interface CompaniesSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  showFavoritesOnly: boolean;
  setShowFavoritesOnly: (show: boolean) => void;
}

export const CompaniesSearch = ({ 
  searchTerm, 
  setSearchTerm,
  showFavoritesOnly,
  setShowFavoritesOnly
}: CompaniesSearchProps) => {
  const { t } = useTranslation();
  return (
    <div className="mb-6 flex flex-col sm:flex-row gap-3">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
        <Input 
          type="text"
          placeholder={t("companies.searchPlaceholder")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10 pr-10"
        />
        {searchTerm && (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="absolute right-1 top-1/2 transform -translate-y-1/2 h-8 w-8 p-0"
            onClick={() => setSearchTerm('')}
          >
            <X className="h-4 w-4" />
            <span className="sr-only">{t("common.clearSearch", "Clear search")}</span>
          </Button>
        )}
      </div>
      
      <FavoriteFilter
        showFavoritesOnly={showFavoritesOnly}
        setShowFavoritesOnly={setShowFavoritesOnly}
      />
    </div>
  );
};
